import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"
import {getExternalCustomers, showAxiosError} from "../../../helper/helper";
import ExternalCustomerModal from "./ExternalCustomerModal";
import {showFastExternalCustomer, showPredefinedBtn} from "../../../helper/permission";
import { ExternalCustomerMainType} from "../../../helper/enums";
import ExternalCustomerPanel from "../../invoice/component/ExternalCustomerPanel";
import {EntegratorConf} from "../../../constants";
import {request} from "../../../helper/APIUtils";

class ExternalCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {modal: false, externalCustomers:[]};
        this.setExternalCustomer = this.setExternalCustomer.bind(this);
        this.onExternalCustomerChange = this.onExternalCustomerChange.bind(this);
        this.editExternalCustomer = this.editExternalCustomer.bind(this);
        this.clearExternalCustomer = this.clearExternalCustomer.bind(this);
        this.arrowRenderer = this.arrowRenderer.bind(this);
        this.formatCreateLabelCreator = this.formatCreateLabelCreator.bind(this);
        this.lengthCheck = this.lengthCheck.bind(this);
        this.numberCheck = this.numberCheck.bind(this);
    }

    componentWillMount() {
        let {externalCustomer, externalCustomerAddress} = this.props;
        this.setState({externalCustomer, externalCustomerAddress});
    }

    clearExternalCustomer() {
        let externalCustomer = {
            commerceChamber: null,
            customer: null,
            externalCustomerAddressList: [],
            familyName: null,
            formattedName: null,
            givenName: null,
            mersisNumber: null,
            middleName: null,
            recordId: null,
            taxOffice: null,
            title: null,
            tradeRegistrationNumber: null,
            vknTckn: null
        };

        let externalCustomerAddress = {
            buildingName: null,
            buildingNo: null,
            cityName: null,
            citySubdivisionName: null,
            countryName: null,
            email: null,
            fax: null,
            postalAddressRegion: null,
            postalAddressRoom: null,
            postalZone: null,
            postboxAlias: null,
            recordId: null,
            streetName: null,
            telephone: null,
            webSite: null
        };

        this.setState({
            externalCustomer: externalCustomer,
            externalCustomerAddress: externalCustomerAddress,
            modal: false
        });
        this.props.listener(externalCustomer, externalCustomerAddress);
    }

    setExternalCustomer(externalCustomer, externalCustomerAddress, sendParent, modal) {
        this.setState({
            externalCustomer: externalCustomer,
            externalCustomerAddress: externalCustomerAddress,
            modal: modal
        });
        if (sendParent)
            this.props.listener(externalCustomer, externalCustomerAddress);
    }

    onExternalCustomerChange(item) {
        let externalCustomer = JSON.parse(item.value);
        let externalCustomerAddress = {};
        if (externalCustomer.externalCustomerAddressList.length > 0) {
            let externalCustomerDefaultAddress = externalCustomer.externalCustomerAddressList.filter((f) => f.defaultAddress === true)
            externalCustomerAddress = externalCustomerDefaultAddress.length > 0 ? externalCustomerDefaultAddress[0] : externalCustomer.externalCustomerAddressList[0];
            if (externalCustomerAddress.despatchPostboxAlias === null && externalCustomerAddress.postboxAlias === null){
                let params = {
                    url: '/externalCustomer/fetchPkList',
                    data: externalCustomer.vknTckn,
                    method: 'post'
                };
                request(params).then((response) => {
                    let pkList = response.data;
                    let invoicePkList = [];
                    let despatchPkList = [];
                    if (pkList.length !== 0) {
                        invoicePkList = pkList.filter(pk => pk.documentType === 'Invoice');
                        despatchPkList = pkList.filter(pk => pk.documentType === 'DespatchAdvice');
                        externalCustomerAddress = {
                            buildingName: externalCustomerAddress.buildingName,
                            buildingNo: externalCustomerAddress.buildingNo,
                            cityName: externalCustomerAddress.cityName,
                            citySubdivisionName: externalCustomerAddress.citySubdivisionName,
                            countryName: "Türkiye",
                            email: externalCustomerAddress.email,
                            fax: externalCustomerAddress.fax,
                            postalAddressRegion: externalCustomerAddress.postalAddressRegion,
                            postalAddressRoom: externalCustomerAddress.postalAddressRoom,
                            postalZone: externalCustomerAddress.postalZone,
                            postboxAlias: invoicePkList.length !== 0 ? invoicePkList[0].aliasName : "",
                            recordId: externalCustomerAddress.recordId,
                            streetName: externalCustomerAddress.cityName,
                            telephone: externalCustomerAddress.telephone,
                            webSite: externalCustomerAddress.webSite,
                            defaultAddress: externalCustomerAddress.defaultAddress,
                            despatchPostboxAlias: despatchPkList.length !== 0 ? despatchPkList[0].aliasName : "",
                            gbAlias:externalCustomerAddress.gbAlias
                        };

                        this.setState({externalCustomer: externalCustomer, externalCustomerAddress: externalCustomerAddress});
                        this.props.listener(externalCustomer, externalCustomerAddress);
                    }
                }).catch(function (error) {
                    showAxiosError(error);
                });
            }

            this.setState({externalCustomer: externalCustomer, externalCustomerAddress: externalCustomerAddress});
            this.props.listener(externalCustomer, externalCustomerAddress);
        } else {
            // let params = {
            //     url: `/externalCustomer/findAddressFromTNB`,
            //     method: "post",
            //     data: externalCustomer.vknTckn
            // };
            // request(params)
            // .then(response => {
            //    console.log("data",response.data)
            // })
            // .catch(function (error) {
            //     showAxiosError(error);
            // });

            externalCustomerAddress = {
                buildingName: "",
                buildingNo: "",
                cityName: "",
                citySubdivisionName: "",
                countryName: "Türkiye",
                email: "",
                fax: "",
                postalAddressRegion: "",
                postalAddressRoom: "",
                postalZone: "",
                postboxAlias: "",
                recordId: null,
                streetName: "",
                telephone: "",
                webSite: "",
            };
            this.setState({externalCustomer: externalCustomer, externalCustomerAddress: externalCustomerAddress});
            this.props.listener(externalCustomer, externalCustomerAddress);
        }
    }

    editExternalCustomer() {
        let externalCustomer = this.props.externalCustomer;
        let externalCustomerAddress = this.props.externalCustomerAddress;
        this.setState({
            externalCustomer: externalCustomer,
            externalCustomerAddress: externalCustomerAddress,
            modal: true,
            docType: this.props.docType
        });
    }

    arrowRenderer(e) {
        let onMouseDown = e.onMouseDown;
        return React.createElement('span', {
            className: 'search',
            onMouseDown: onMouseDown
        });
    }

    formatCreateLabelCreator (value){
        if( ['EARSIVFATURA', 'EFATURA'].includes(this.props.docType)  && showPredefinedBtn())
            return `${value} nolu vkn/tckn için e-Arşiv Fatura oluştur.`;
    };

    setExternalCustomers(externalCustomers,options){
        let self=this;
        self.setState({externalCustomers: externalCustomers});
            return options;
    }

    lengthCheck(vkn) {
        return vkn.length === 10 || vkn.length === 11;
    };

    numberCheck(vkn){
        return !isNaN(parseInt(vkn));
    };

  /*  async renderNewUserAlert (vkn) {
        if( !(['EARSIVFATURA', 'EFATURA'].includes(this.props.docType) && showPredefinedBtn()) )
            return;
        let self=this;
        let alert = <SweetAlert showCancel warning
                                confirmBtnText="Tamam"
                                cancelBtnText="İptal"
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="default"
                                title="Onay"
                                onConfirm={async () => {
                                    let externalCustomer = {
                                        commerceChamber: null,
                                        customer: null,
                                        externalCustomerAddressList: [],
                                        familyName: "",
                                        formattedName: "",
                                        givenName: "",
                                        mersisNumber: "",
                                        middleName: "",
                                        recordId: null,
                                        taxOffice: "",
                                        title: "",
                                        tradeRegistrationNumber: "",
                                        vknTckn: vkn
                                    };
                                    let externalCustomerAddress = {
                                        buildingName: "",
                                        buildingNo: "",
                                        cityName: "",
                                        citySubdivisionName: "",
                                        countryName: "Türkiye",
                                        email: "",
                                        fax: "",
                                        postalAddressRegion: "",
                                        postalAddressRoom: "",
                                        postalZone: "",
                                        postboxAlias: "",
                                        recordId: null,
                                        streetName: "",
                                        telephone: "",
                                        webSite: "",
                                    };

                                    self.setState({externalCustomer, externalCustomerAddress, alert: null});
                                    let result = await self.props.listenerAsync(externalCustomer, externalCustomerAddress);
                                    let pre = {
                                        invoiceTypeInfo: {
                                            invoiceTypeCode: "SATIS",
                                            profileId: "EARSIVFATURA",
                                            accountingCost: null
                                        },
                                    };
                                    self.props.setPredefinedType(pre,false);
                                }}
                                onCancel={() => self.setState({alert: null})}>
            {vkn} vkn/tckn numaralı kullanıcı GİB E-Fatura listesinde veya daha önceki müşterilerinizde kayıtlı değil.
            E-Arşiv Fatura olarak gönderilecek.
        </SweetAlert>;
        self.setState({alert});
    };*/


    render() {
        const type = ((this.props.isDespatchMixedCustomer  && this.props.isDespatchMixedCustomer) ? "despatchMixedCustomer" : (this.props.includeForeign ? "includeForeign" : "externalCustomer") );
        return (
            <div className="row">
                {this.state.alert}
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row" style={{marginBottom: '20px'}}>
                    <div className="col-sm-9">
                        <div className="form-group">
                            <Select.Async multi={false}
                                          ignoreAccents={false}
                                          disabled={this.props.invoiceTypeCode === "SGK"}
                                          value={this.props.externalCustomer !== null ? (this.props.externalCustomer.vknTckn ? {
                                              value: JSON.stringify(this.props.externalCustomer),
                                              label: this.props.externalCustomer.vknTckn ? (this.props.externalCustomer.vknTckn + "-" + (this.props.externalCustomer.title || this.props.externalCustomer.formattedName || (this.props.externalCustomer.givenName + " " + this.props.externalCustomer.familyName))) : null
                                          } : null) : null}
                                          onChange={(e) => e && this.onExternalCustomerChange(e)}
                                          isLoading={true}
                                          autoload={false}
                                          cache={false}
                                          clearable={false}
                                          arrowRenderer={this.arrowRenderer}
                                          noResultsText="Kayıt bulunamadı."
                                          searchPromptText="Arama için en az 3 karakter giriniz."
                                          placeholder="Unvan veya VKN/TCKN ile arama yapabilirsiniz"
                                          loadingPlaceholder="Yükleniyor..."
                                          loadOptions={(key) => getExternalCustomers(key, this.props.checkGibUser, type, this.props.docType)}
                                          showNewOptionAtTop={false}
                                          required={true}
                                          cacheOptions
                                          defaultOptions/>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            <button type="button"
                                    className="TekBtn delete bHizala"
                                    disabled={this.props.invoiceTypeCode === "SGK"}
                                    onClick={this.clearExternalCustomer}
                                    style={{background: '#FFCCCC'}}
                            >Temİzle
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>VKN/TCKN</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomer ? (this.props.externalCustomer.vknTckn ? this.props.externalCustomer.vknTckn : "") : ""}/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>Unvan</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomer ? ((this.props.externalCustomer.givenName || "") + " " +
                                       (this.props.externalCustomer.familyName || "") + " " +
                                       (this.props.externalCustomer.formattedName || "")).trim() : ""}/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>Vergi D.</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomer ? this.props.externalCustomer.taxOffice || "" : ""}/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>Adres</label></div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomerAddress ? ((this.props.externalCustomerAddress.postalAddressRegion || "") + " " +
                                       (this.props.externalCustomerAddress.streetName || "") + " " +
                                       (this.props.externalCustomerAddress.buildingName || "") + " " +
                                       (this.props.externalCustomerAddress.buildingNo || "") + " " +
                                       (this.props.externalCustomerAddress.postalAddressRoom || "") + " " +
                                       (this.props.externalCustomerAddress.postalZone || "") + " " +
                                       (this.props.externalCustomerAddress.citySubdivisionName || "") + " " +
                                       (this.props.externalCustomerAddress.cityName || "") + " " +
                                       (this.props.externalCustomerAddress.countryName || "")).trim() : ""
                                   }/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>e-Posta</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomerAddress ? this.props.externalCustomerAddress.email || "" : ""}/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>Telefon</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomerAddress ? this.props.externalCustomerAddress.telephone || "" : ""}/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>Faks</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomerAddress ? this.props.externalCustomerAddress.fax || "" : ""}/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
                     style={{marginRight: '0', padding: '0 0 0 15px'}}>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <label>Web Sitesi</label></div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                        <div className="form-group">
                            <input className="form-control"
                                   disabled
                                   type="text"
                                   value={this.props.externalCustomerAddress ? this.props.externalCustomerAddress.webSite || "" : ""}/>
                        </div>
                    </div>
                </div>

                {this.props.invoiceTypeCode !== "SGK" &&
                    <div className=" col-sm-12">
                        <div className="form-group">
                            <button type="button"
                                    className={"TekBtn pull-right " + (this.props.externalCustomer ? (this.props.externalCustomer.vknTckn ? "edit" : "ekle") : "ekle")}
                                    style={{
                                        marginBottom: '5px',
                                        marginTop: '10px',
                                        marginRight: '28px',
                                        padding: '9px 54px 9px 23px',
                                        background: (this.props.externalCustomer ? (this.props.externalCustomer.vknTckn ? 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))' : '') : '')
                                    }}
                                    onClick={this.editExternalCustomer}>{this.props.externalCustomer ? (this.props.externalCustomer.vknTckn ? "Alıcı Düzenle" : "Alıcı Oluştur") : "Alıcı Oluştur"}
                            </button>
                        </div>
                    </div>
                }

                {this.props.docType === "EARSIVFATURA" && this.props.taxInclusiveAmount >= 9900 &&
                    <div style={{marginRight: '0', marginTop:'20px', padding: '0 0 0 15px'}}>
                        <div>
                            <label style={{wordWrap: 'break-word', whiteSpace: 'normal',color: 'red'}}>
                                <i className="fas fa-exclamation-circle" style={{color: 'red', marginRight: '8px'}}></i>
                                2025 yılı itibarıyla, 9.900 TL ve üzeri faturalar için alıcının adı, soyadı
                                ve TC kimlik numarası (veya firma adı ve VKN) zorunludur. Bu bilgileri sağlamadan bu tür faturalar kesilemez.
                            </label>
                        </div>
                    </div>
                }
                {this.state.modal &&
                    ((showFastExternalCustomer(EntegratorConf.identifier) && !this.props.externalCustomer.vknTckn) ?
                            <ExternalCustomerPanel title={this.props.title}
                                                   requiredTaxOffice={this.props.requiredTaxOffice}
                                                   type={null}
                                                   docType={this.state.docType}
                                                   listener={this.setExternalCustomer}
                                                   modal={this.state.modal}
                                                   cities={this.props.cities}
                                                   countries={this.props.countries}
                                                   externalCustomerMainType={this.props.isDespatchMixedCustomer ? ExternalCustomerMainType.DespatchMixed : ExternalCustomerMainType.Normal}/>
                            :
                            <ExternalCustomerModal title={this.props.title}
                                                   requiredTaxOffice={this.props.requiredTaxOffice}
                                                   type={null}
                                                   docType={this.state.docType}
                                                   listener={this.setExternalCustomer}
                                                   modal={this.state.modal}
                                                   cities={this.props.cities}
                                                   externalCustomer={this.state.externalCustomer}
                                                   externalCustomerAddress={this.state.externalCustomerAddress}
                                                   countries={this.props.countries}
                                                   externalCustomerMainType={this.props.isDespatchMixedCustomer ? ExternalCustomerMainType.DespatchMixed : ExternalCustomerMainType.Normal}/>
                    )
                }
            </div>
        );
    }
}

export default ExternalCustomer;
